import { Component, Input } from "@angular/core";
import { AvailableSkeletonTypes } from "./skeleton.interfaces";

@Component({
  selector: "app-skeleton",
  templateUrl: "./skeleton.component.html",
  styleUrls: ["./skeleton.component.css"],
})
export class SkeletonComponent {
  @Input()
  skeletonType?: AvailableSkeletonTypes;
}
